var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3818_5045)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 80,
    height: 80,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3818_5045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.25 45.0938C60.25 46.0602 59.4664 46.8438 58.5 46.8438H52.5938V52.75C52.5938 53.7164 51.8102 54.5 50.8438 54.5H45.1562C44.1898 54.5 43.4062 53.7164 43.4062 52.75V46.8438H37.5C36.5336 46.8438 35.75 46.0602 35.75 45.0938V39.4062C35.75 38.4396 36.5336 37.6562 37.5 37.6562H43.3078V31.75C43.3078 30.7833 44.0914 30 45.0578 30H50.7453C51.7118 30 52.4953 30.7833 52.4953 31.75V37.6562H58.5C59.4664 37.6562 60.25 38.4396 60.25 39.4062V45.0938Z",
    fill: "#BE143C",
    fillOpacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.0001 19.4014C32.5345 19.4014 20.0985 29.5831 20.0985 42.1514C20.0985 47.5753 22.437 52.4436 26.3296 56.4467C24.9624 61.9581 20.3895 66.8701 20.3348 66.9248C20.0001 67.2748 19.9351 67.6467 20.0753 67.9748C20.2188 68.3029 20.5265 68.4995 20.875 68.4995C28.1277 68.4995 33.5625 65.0214 36.2532 62.8765C39.8319 64.2229 43.8011 64.9995 48 64.9995C63.4657 64.9014 76.0001 54.817 76.0001 42.1514C76.0001 29.4857 63.4657 19.4014 48.0001 19.4014ZM60.2501 45.0936C60.2501 46.06 59.4665 46.8436 58.5001 46.8436H52.5938V52.7498C52.5938 53.7162 51.8103 54.4998 50.8438 54.4998H45.1563C44.1899 54.4998 43.4063 53.7162 43.4063 52.7498V46.8436H37.5001C36.5337 46.8436 35.7501 46.06 35.7501 45.0936V39.4061C35.7501 38.4394 36.5337 37.6561 37.5001 37.6561H43.3079V31.7498C43.3079 30.7831 44.0915 29.9998 45.0579 29.9998H50.7454C51.7118 29.9998 52.4954 30.7831 52.4954 31.7498V37.6561H58.5001C59.4665 37.6561 60.2501 38.4394 60.2501 39.4061V45.0936Z",
    fill: "#BE143C",
    fillOpacity: 0.74
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 78,
    height: 78,
    rx: 15,
    stroke: "#DDDAD7",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3818_5045",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.160784 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3818_5045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3818_5045",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_5045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(20 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.a4cf4a68de0e6b45d1402e000a8ed06f.svg";
export { ForwardRef as ReactComponent };